import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const TermsConditions = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <div className="legal-container">
        <button onClick={() => navigate('/')} className="back-button">
          <ArrowLeft size={20} /> Back to Home
        </button>
        
        <h1 className="legal-title">Terms & Conditions</h1>
        <p className="legal-updated">Last Updated: January 2025</p>

        <div className="legal-content">
          <section className="legal-section">
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using Bizenntrum's website and services, you accept and agree to be bound by these Terms and Conditions. 
              If you do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Services Description</h2>
            <p>
              Bizenntrum provides strategic finance, tax, and legal consulting services for businesses operating in the 
              India-Singapore-ASEAN corridor. Our services include but are not limited to:
            </p>
            <ul>
              <li>Strategic growth advisory</li>
              <li>CFO and financial services</li>
              <li>Tax planning and compliance</li>
              <li>Legal and regulatory advisory</li>
              <li>Market entry and expansion support</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. Professional Relationship</h2>
            <p>
              Our services are provided through a strategic partnership model. Engagement with Bizenntrum does not 
              create an attorney-client, accountant-client, or fiduciary relationship unless explicitly agreed upon 
              in a separate engagement letter.
            </p>
          </section>

          <section className="legal-section">
            <h2>4. Use of Website</h2>
            <h3>4.1 Permitted Use</h3>
            <p>You agree to use our website only for lawful purposes and in accordance with these Terms.</p>

            <h3>4.2 Prohibited Activities</h3>
            <p>You may not:</p>
            <ul>
              <li>Use the website in any way that violates applicable laws or regulations</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Interfere with the proper functioning of the website</li>
              <li>Use automated systems to access the website without permission</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. Intellectual Property</h2>
            <p>
              All content on this website, including text, graphics, logos, and software, is the property of Bizenntrum 
              or its licensors and is protected by intellectual property laws. You may not reproduce, distribute, or 
              create derivative works without our express written permission.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Consultation and Engagement</h2>
            <h3>6.1 Initial Consultation</h3>
            <p>
              Initial consultations are provided for informational purposes only and do not constitute professional advice. 
              Formal engagement requires a signed service agreement.
            </p>

            <h3>6.2 Service Agreements</h3>
            <p>
              Detailed terms of service, fees, and deliverables will be outlined in separate engagement letters or 
              service agreements for each client engagement.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by law, Bizenntrum and its partners shall not be liable for any indirect, 
              incidental, special, or consequential damages arising from:
            </p>
            <ul>
              <li>Use or inability to use our services or website</li>
              <li>Unauthorized access to or alteration of your data</li>
              <li>Any other matter relating to our services</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>8. Disclaimer of Warranties</h2>
            <p>
              Our services and website are provided "as is" without warranties of any kind, either express or implied. 
              We do not guarantee that our services will be uninterrupted, error-free, or completely secure.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Confidentiality</h2>
            <p>
              We maintain strict confidentiality of client information. However, specific confidentiality obligations 
              will be detailed in individual engagement agreements.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Governing Law and Jurisdiction</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of Singapore. Any disputes 
              arising from these Terms shall be subject to the exclusive jurisdiction of Singapore courts.
            </p>
          </section>

          <section className="legal-section">
            <h2>11. Indemnification</h2>
            <p>
              You agree to indemnify and hold harmless Bizenntrum, its partners, and affiliates from any claims, 
              damages, or expenses arising from your use of our services or violation of these Terms.
            </p>
          </section>

          <section className="legal-section">
            <h2>12. Changes to Terms</h2>
            <p>
              We reserve the right to modify these Terms at any time. Changes will be effective immediately upon 
              posting to the website. Continued use of our services constitutes acceptance of modified Terms.
            </p>
          </section>

          <section className="legal-section">
            <h2>13. Severability</h2>
            <p>
              If any provision of these Terms is found to be unenforceable, the remaining provisions shall continue 
              in full force and effect.
            </p>
          </section>

          <section className="legal-section">
            <h2>14. Contact Information</h2>
            <p>
              For questions about these Terms & Conditions, please contact us at:
            </p>
            <p>
              <strong>Email:</strong> opsdesk@bizenntrum.com<br />
              <strong>WhatsApp:</strong> +65 8017 9673<br />
              <strong>Location:</strong> Singapore | India (Hyderabad, Mumbai, Chennai)
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
